export interface ResetPassword{
    username:string,
    password:string,
    status:boolean,
    resetPasswordGuid:string,
}

export function defaultRPValues():ResetPassword{
    return {username:"",password:"",status:true,resetPasswordGuid:''}
}